import { Container, Row } from "react-bootstrap";
import { postCustomizePage } from "services/post-customizePage";
import { getPremiumWifiPage } from "services/get-premiumWifiPage";
import { useSetRecoilState } from "recoil";
import { showPremiumWifiModalState, mobileRegistryModalState, showAdvertisingModalState, adActionsState, advertisingModalDataState } from "atoms";
import { useWrapRequest } from "utils";
import { useNavigate } from "react-router-dom";
import { PATH } from "utils/const";

const BackToPlansMobileButton = () => {
  const setShowPremiumWifiModal = useSetRecoilState(showPremiumWifiModalState);
  const setShowMobileRegistryModal = useSetRecoilState(mobileRegistryModalState);
  const setShowAdvertisingModal = useSetRecoilState(showAdvertisingModalState);
  const setAdActions = useSetRecoilState(adActionsState);
  const setAdvertisingModalData = useSetRecoilState(advertisingModalDataState);
  const wrapRequest = useWrapRequest();
  const navigate = useNavigate();

  const onContinue = () => {
    const onContinueAsync = async () => {
      const response = await postCustomizePage();
      if (response.ecommerceAction === "prompt" && response.ecommerceMessageType === "modal") {
        await getPremiumWifiPage();
        if (response["_embedded"]?.["ec:ad"] && response["_embedded"]?.["ec:adActions"]) {
          setAdvertisingModalData(response["_embedded"]["ec:ad"]);
          setShowAdvertisingModal(true);
          setAdActions(response["_embedded"]["ec:adActions"]);
        } else {
          setShowPremiumWifiModal(true);
        }
      } else if (response.ecommerceAction === "error") {
        throw response.message;
      } else {
        if (response._links?.["ec:windowLocation"]?.href) {
          navigate(response._links["ec:windowLocation"].href);
        }
      }
    };
    wrapRequest(onContinueAsync, {
      afterFinally: () => {
        setShowMobileRegistryModal(false);
      },
    });
  };

  return (
    <>
      <Container className="mobile-back-to-all-plans-container">
        <Row>
          <div className="step-title-back-to-plans">Customize Order</div>
          <hr />
          <div className="mobile-back-to-all-plans">
            <div className="back-to-plans">
              <a className="continue-shopping-link-a-tag text-decoration-none" href={PATH.BROWSE}>
                <i style={{ fontSize: "x-large" }} className="text-pastel-light-blue me-2 fa-sharp fa-solid fa-chevron-left"></i>
                <span className="text-pastel-light-blue align-top fw-bold h5">Continue Shopping</span>
              </a>
            </div>
            <div className="back-to-plans-continue-button">
              <button className="btn cart-registry-button" onClick={() => onContinue()}>
                Continue
              </button>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default BackToPlansMobileButton;
